import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

export const UppercaseTypography = withStyles({
  root: {
    textTransform: 'uppercase',
  },
})(Typography);
